<template lang="pug">
.container-restricao
    .card-restricao(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido !== "undefined" && restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in restricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricao)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.gmlid') }}:
                |
                | {{ restricao?.gmlid || restricao?.properties?.gmlid || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cod_origem') }}:
                |
                | {{ restricao?.cod_origem || restricao?.properties?.cod_origem || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.data_lavratura') }}:
                |
                | {{ formatDate(restricao?.data_lavratura ?? restricao?.properties?.data_lavratura) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.data_cadastro') }}:
                |
                | {{ formatDate(restricao?.data_cadastro ?? restricao?.properties?.data_cadastro) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.natureza_embargo') }}:
                |
                | {{ restricao?.natureza_embargo || restricao?.properties?.natureza_embargo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.justificativa_embargo') }}:
                |
                | {{ restricao?.justificativa_embargo || restricao?.properties?.justificativa_embargo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.descricao_acesso_embargo') }}:
                |
                | {{ restricao?.descricao_acesso_embargo || restricao?.properties?.descricao_acesso_embargo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.descricao_interdito_embargo') }}:
                |
                | {{ restricao?.descricao_interdito_embargo || restricao?.properties?.descricao_interdito_embargo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.tipo_termo') }}:
                |
                | {{ restricao?.tipo_termo || restricao?.properties?.tipo_termo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.condicao_termo') }}:
                |
                | {{ restricao?.condicao_termo || restricao?.properties?.condicao_termo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nao_identificado') }}:
                |
                | {{ restricao?.nao_identificado || restricao?.properties?.nao_identificado || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.autuado_nao_assinou') }}:
                |
                | {{ restricao?.autuado_nao_assinou || restricao?.properties?.autuado_nao_assinou || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.autuado_nao_cientificado') }}:
                |
                | {{ restricao?.autuado_nao_cientificado || restricao?.properties?.autuado_nao_cientificado || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.autuado_nao_alfabetizado') }}:
                |
                | {{ restricao?.autuado_nao_alfabetizado || restricao?.properties?.autuado_nao_alfabetizado || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipio_termo') }}:
                |
                | {{ restricao?.municipio_termo || restricao?.properties?.municipio_termo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome_pessoa_termo') }}:
                |
                | {{ restricao?.nome_pessoa_termo || restricao?.properties?.nome_pessoa_termo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpf_cnpj_pessoa_termo') }}:
                |
                | {{ restricao?.cpf_cnpj_pessoa_termo || restricao?.properties?.cpf_cnpj_pessoa_termo || '-' }}

                Criticidade(
                    v-if='restricao?.nivelAlerta || restricao?.properties?.nivelAlerta',
                    :restricao='restricao?.properties ? restricao?.properties : restricao'
                )

</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';

export default {
    name: 'embargos-remotos-ipaam',
    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        Criticidade
    },
    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (isNaN(number)) {
                return '-';
            }
            let floatNumber = parseFloat(number);
            return floatNumber.toLocaleString('pt-BR', {
                maximumFractionDigits: 2
            });
        },
        formatDate(date) {
            if (!date) return '-';
            return formatters.formatDate(date);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        formatCpfCnpj(cpfCnpj) {
            if (!cpfCnpj) return '-';
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        },
        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao;

            if (properties?.latitude && properties?.longitude) {
                return true;
            }

            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    }
};
</script>

<style lang="scss"></style>
